// UI telemetry — where user clicked Extract Now. Mixpanel-only, never sent to the API.
export const CLICK_SOURCE = {
    BANNER: 'banner',
    EMPTY_STATE: 'empty_state',
} as const;
export type ClickSource = (typeof CLICK_SOURCE)[keyof typeof CLICK_SOURCE];

// Wire value sent to the extract API. Always EXTRACT_NOW from this client.
export const TRIGGER_SOURCE = {
    EXTRACT_NOW: 'EXTRACT_NOW',
    AUTO_STATUS_CHANGE: 'AUTO_STATUS_CHANGE',
} as const;
export type TriggerSource = (typeof TRIGGER_SOURCE)[keyof typeof TRIGGER_SOURCE];

// Banner state — PENDING shows the warning + Extract Now CTA, IN_PROGRESS shows the
// X/Y progress spinner. Drives both the parent's mount gate and the banner's render branch.
export const BANNER_MODE = {
    PENDING: 'pending',
    IN_PROGRESS: 'inProgress',
} as const;
export type BannerMode = (typeof BANNER_MODE)[keyof typeof BANNER_MODE];
